export const createCompositeKey = (name: string) => {
    const words = name.split(' ');

    // Remove the last element
    words.pop();

    // Create a camel case string
    const camelCaseString = words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');

    // Ensure the first letter is lowercase
    return camelCaseString.charAt(0).toLowerCase() + camelCaseString.slice(1);
};
